import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../services/api';

const ENG_STATUS = [
  { v:'aguardando_engenheiro',         l:'Aguardando Engenheiro' },
  { v:'a_pagar_crt',                   l:'A Pagar CRT' },
  { v:'analise_cemig',                 l:'Análise CEMIG' },
  { v:'parecer_aprovado',              l:'Parecer Aprovado' },
  { v:'parecer_reprovado',             l:'Parecer Reprovado' },
  { v:'aguardando_solicitar_vistoria', l:'Aguardando Solicitar Vistoria' },
  { v:'vistoria_solicitada',           l:'Vistoria Solicitada' },
  { v:'vistoria_concluida',            l:'Vistoria Concluída' },
];

const S = {
  label: { fontSize:11, color:'#64748b', textTransform:'uppercase', letterSpacing:1, marginBottom:5, display:'block' },
  input: { width:'100%', padding:'9px 11px', borderRadius:7, background:'#0f1117', border:'1px solid #1a2035', color:'#e2e8f0', fontSize:13, outline:'none', marginBottom:12 },
  inputSel: { width:'100%', padding:'9px 11px', borderRadius:7, background:'#0f1117', border:'1px solid #1a2035', color:'#e2e8f0', fontSize:13, outline:'none', marginBottom:12 },
  btn: (c='#f6c90e') => ({ display:'flex', alignItems:'center', gap:5, padding:'6px 12px', borderRadius:7, background:`${c}22`, color:c, fontSize:12, fontWeight:600, cursor:'pointer', border:`1px solid ${c}44` }),
};

const fmtDate = (d) => d ? new Date(d + (d.includes('T') ? '' : 'T12:00:00')).toLocaleDateString('pt-BR') : '—';
const fmtDT2 = (d) => d ? new Date(d).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '—';

export default function EngenheiroViewPosVenda({ engId }) {
  const [edata, setEdata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [showDocs, setShowDocs] = useState(false);
  const [savingEngStatus, setSavingEngStatus] = useState(false);
  const [engStatusError, setEngStatusError] = useState('');
  const [engForm, setEngForm] = useState({});

  const [boletoFile, setBoletoFile] = useState(null);
  const [uploadingBoleto, setUploadingBoleto] = useState(false);
  const [boletoError, setBoletoError] = useState('');
  const boletoInputRef = useRef();

  const [crtFile, setCrtFile] = useState(null);
  const [uploadingCrt, setUploadingCrt] = useState(false);
  const [crtError, setCrtError] = useState('');
  const crtInputRef = useRef();

  const loadEdata = useCallback(async () => {
    if (!engId) return;
    try {
      const r = await api.get(`/engenheiro/${engId}/`);
      setEdata(r.data);
      setEngForm({
        data_crt_pagamento: r.data.data_crt_pagamento || '',
        data_analise_cemig_retorno: r.data.data_analise_cemig_retorno || '',
        data_vistoria_concluida: r.data.data_vistoria_concluida || '',
      });
    } catch (e) {
      setError('Erro ao carregar dados do engenheiro.');
    } finally {
      setLoading(false);
    }
  }, [engId]);

  useEffect(() => { loadEdata(); }, [loadEdata]);

  // ef('field') → onBlur handler que atualiza engForm
  const ef = (field) => (e) => setEngForm(prev => ({ ...prev, [field]: e.target.value }));

  const definirStatusEng = async (novoStatus) => {
    if (!edata?.id || !novoStatus || novoStatus === edata.status) return;
    setSavingEngStatus(true); setEngStatusError('');
    try {
      const r = await api.patch(`/engenheiro/${edata.id}/`, { status: novoStatus });
      setEdata(prev => ({ ...prev, ...r.data }));
    } catch (e) {
      setEngStatusError(e.response?.data?.error || 'Erro ao alterar status.');
    } finally {
      setSavingEngStatus(false);
    }
  };

  const avancarEng = async (novoStatus, extra = {}) => {
    setSavingEngStatus(true); setEngStatusError('');
    try {
      const r = await api.post(`/engenheiro/${edata.id}/avancar-status/`, { status: novoStatus, ...extra });
      setEdata(prev => ({ ...prev, ...r.data }));
    } catch (e) {
      setEngStatusError(e.response?.data?.error || 'Erro ao avançar status.');
    } finally {
      setSavingEngStatus(false);
    }
  };

  if (!engId) return null;
  if (loading) return (
    <div style={{ padding:'16px 0', fontSize:13, color:'#475569' }}>Carregando dados do engenheiro…</div>
  );
  if (error) return (
    <div style={{ padding:'12px 14px', borderRadius:8, background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', fontSize:12, color:'#f87171', marginTop:12 }}>{error}</div>
  );
  if (!edata) return null;

  const st = edata.status;

  const StatusBadge = ({ st: s }) => {
    const labels = { aguardando_engenheiro:'Aguardando Engenheiro', a_pagar_crt:'A Pagar CRT', analise_cemig:'Análise CEMIG', parecer_aprovado:'Parecer Aprovado', parecer_reprovado:'Parecer Reprovado', aguardando_solicitar_vistoria:'Aguardando Solicitar Vistoria', vistoria_solicitada:'Vistoria Solicitada', vistoria_concluida:'Vistoria Concluída' };
    const colors = { aguardando_engenheiro:'#94a3b8', a_pagar_crt:'#fb923c', analise_cemig:'#60a5fa', parecer_aprovado:'#4ade80', parecer_reprovado:'#f87171', aguardando_solicitar_vistoria:'#a78bfa', vistoria_solicitada:'#f6c90e', vistoria_concluida:'#4ade80' };
    const c = colors[s] || '#64748b';
    return (
      <div style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 12px', borderRadius:8, background:`${c}15`, border:`1px solid ${c}40`, marginBottom:12 }}>
        <span style={{ width:8, height:8, borderRadius:'50%', background:c, flexShrink:0 }} />
        <span style={{ fontSize:13, fontWeight:700, color:c }}>{labels[s] || s}</span>
      </div>
    );
  };

  const PanelBox = ({ color, children }) => (
    <div style={{ background:`${color}08`, border:`1px solid ${color}25`, borderRadius:10, padding:14, marginTop:8 }}>
      {children}
    </div>
  );

  const FileLink = ({ label, href }) => (
    <a href={href} target="_blank" rel="noopener noreferrer"
      style={{ display:'flex', alignItems:'center', gap:6, padding:'6px 10px', borderRadius:7, fontSize:12, fontWeight:600, textDecoration:'none', background:'rgba(96,165,250,0.1)', border:'1px solid rgba(96,165,250,0.3)', color:'#60a5fa' }}>
      📄 {label}
    </a>
  );

  const ImgLink = ({ label, href }) => (
    <a href={href} target="_blank" rel="noopener noreferrer"
      style={{ display:'flex', alignItems:'center', gap:6, padding:'6px 10px', borderRadius:7, fontSize:12, fontWeight:600, textDecoration:'none', background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.25)', color:'#4ade80' }}>
      🖼 {label}
    </a>
  );

  const MissingTag = ({ label }) => (
    <span style={{ display:'flex', alignItems:'center', gap:6, padding:'6px 10px', borderRadius:7, fontSize:12, background:'rgba(71,85,105,0.1)', border:'1px solid rgba(71,85,105,0.2)', color:'#475569' }}>— {label}</span>
  );

  const Secao = ({ titulo, itens, isImagem }) => {
    const entries = Object.entries(itens);
    if (entries.length === 0) return null;
    return (
      <div style={{ marginBottom:12 }}>
        <div style={{ fontSize:10, color:'#475569', textTransform:'uppercase', letterSpacing:0.8, fontWeight:700, marginBottom:6 }}>{titulo}</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:5 }}>
          {entries.map(([label, href]) =>
            href
              ? isImagem ? <ImgLink key={label} label={label} href={href} /> : <FileLink key={label} label={label} href={href} />
              : <MissingTag key={label} label={label} />
          )}
        </div>
      </div>
    );
  };

  const docs = edata.documentos_engenheiro;

  return (
    <div style={{ marginTop:20, borderTop:'1px solid #1a2035', paddingTop:16 }}>
      <div style={{ fontSize:11, color:'#f6c90e', textTransform:'uppercase', letterSpacing:1.5, fontWeight:700, marginBottom:14, borderBottom:'1px solid #1a2035', paddingBottom:6 }}>
        🔧 Trabalho do Engenheiro
      </div>

      {/* ── Ver Documentos ── */}
      {docs && (
        <div style={{ marginBottom:16 }}>
          <button
            type="button"
            onClick={() => setShowDocs(v => !v)}
            style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 14px', borderRadius:9, cursor:'pointer', background:'rgba(246,201,14,0.07)', border:'1px solid rgba(246,201,14,0.25)', color:'#f6c90e', fontSize:13, fontWeight:700 }}
          >
            <span>📁 Ver Documentos</span>
            <span style={{ fontSize:11 }}>{showDocs ? '▲ Fechar' : '▼ Abrir'}</span>
          </button>

          {showDocs && (
            <div style={{ marginTop:10, background:'rgba(0,0,0,0.2)', border:'1px solid #1a2035', borderRadius:10, padding:'14px 16px' }}>

              {/* Kit */}
              {docs.kit && (
                <div style={{ marginBottom:14, background:'rgba(246,201,14,0.06)', border:'1px solid rgba(246,201,14,0.2)', borderRadius:8, padding:'10px 14px' }}>
                  <div style={{ fontSize:10, color:'#f6c90e', textTransform:'uppercase', letterSpacing:0.8, fontWeight:700, marginBottom:6 }}>Kit Solar</div>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:10, fontSize:13, color:'#e2e8f0' }}>
                    <span style={{ background:'rgba(246,201,14,0.12)', color:'#f6c90e', border:'1px solid rgba(246,201,14,0.2)', borderRadius:20, padding:'2px 10px', fontSize:12, fontWeight:700 }}>
                      {docs.kit.geracao} kWh
                    </span>
                    {docs.kit.marca && (
                      <span style={{ background:'rgba(167,139,250,0.12)', color:'#a78bfa', border:'1px solid rgba(167,139,250,0.25)', borderRadius:20, padding:'2px 10px', fontSize:12, fontWeight:700 }}>
                        {docs.kit.marca}
                      </span>
                    )}
                    <span style={{ color:'#cbd5e1' }}>{docs.kit.equipamento}</span>
                    <span style={{ color:'#64748b', fontSize:12 }}>{docs.kit.quantidade}x {docs.kit.placas_w}Wp</span>
                    <span style={{ color:'#4ade80', fontWeight:700, fontSize:12 }}>
                      R$ {Number(docs.kit.valor).toLocaleString('pt-BR', { minimumFractionDigits:2 })}
                    </span>
                  </div>
                </div>
              )}

              <Secao titulo="Fotos do Imóvel" itens={docs.fotos || {}} isImagem={true} />
              <Secao titulo="Documentos do Cliente" itens={docs.docs_cliente || {}} isImagem={false} />
              <Secao titulo="Arquivos Gerados" itens={docs.arquivos_lead || {}} isImagem={false} />
              {Object.values(docs.dados_eng || {}).some(Boolean) && (
                <Secao titulo="Dados do Engenheiro" itens={docs.dados_eng || {}} isImagem={false} />
              )}

              {!docs.kit &&
               !Object.values(docs.fotos || {}).some(Boolean) &&
               !Object.values(docs.docs_cliente || {}).some(Boolean) &&
               !Object.values(docs.arquivos_lead || {}).some(Boolean) &&
               !Object.values(docs.dados_eng || {}).some(Boolean) && (
                <div style={{ fontSize:13, color:'#475569', textAlign:'center', padding:'12px 0' }}>
                  Nenhum arquivo cadastrado ainda.
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── Status sequencial ── */}
      <label style={S.label}>Status atual</label>
      <StatusBadge st={st} />

      {/* Alterar status livremente */}
      <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:16, background:'rgba(246,201,14,0.06)', border:'1px solid rgba(246,201,14,0.2)', borderRadius:8, padding:'8px 10px' }}>
        <label style={{ fontSize:11, color:'#94a3b8', fontWeight:600, whiteSpace:'nowrap' }}>Alterar para qualquer status:</label>
        <select
          value={st}
          disabled={savingEngStatus}
          onChange={(e) => {
            const novoStatus = e.target.value;
            if (novoStatus === st) return;
            const labels = { aguardando_engenheiro:'Aguardando Engenheiro', a_pagar_crt:'A Pagar CRT', analise_cemig:'Análise CEMIG', parecer_aprovado:'Parecer Aprovado', parecer_reprovado:'Parecer Reprovado', aguardando_solicitar_vistoria:'Aguardando Solicitar Vistoria', vistoria_solicitada:'Vistoria Solicitada', vistoria_concluida:'Vistoria Concluída' };
            if (window.confirm(`Confirmar mudança de status para "${labels[novoStatus] || novoStatus}"?`)) {
              definirStatusEng(novoStatus);
            }
          }}
          style={{ ...S.inputSel, width:'auto', flex:'1 1 220px', padding:'6px 10px', fontSize:12 }}
        >
          {ENG_STATUS.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
        </select>
      </div>

      {/* Procuração Assinada */}
      {edata.cemig_assinado_url && (
        <a
          href={edata.cemig_assinado_url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, background:'rgba(96,165,250,0.1)', border:'1px solid rgba(96,165,250,0.3)', color:'#60a5fa', fontSize:12, fontWeight:600, textDecoration:'none', marginBottom:10 }}
        >
          📄 Ver Procuração Assinada
        </a>
      )}

      {/* Boleto */}
      <div style={{ marginBottom:10 }}>
        <div style={{ fontSize:11, color:'#94a3b8', fontWeight:700, textTransform:'uppercase', letterSpacing:1, marginBottom:6 }}>Boleto</div>
        {edata.boleto_url ? (
          <a
            href={edata.boleto_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, background:'rgba(74,222,128,0.1)', border:'1px solid rgba(74,222,128,0.3)', color:'#4ade80', fontSize:12, fontWeight:600, textDecoration:'none' }}
          >📄 Ver Boleto</a>
        ) : (
          <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
            <input
              ref={boletoInputRef}
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={e => { setBoletoFile(e.target.files[0] || null); setBoletoError(''); }}
              style={{ display:'none' }}
            />
            <button
              type="button"
              disabled={uploadingBoleto}
              onClick={async () => {
                if (!boletoFile) { boletoInputRef.current?.click(); return; }
                setUploadingBoleto(true); setBoletoError('');
                try {
                  const fd = new FormData();
                  fd.append('arquivo', boletoFile);
                  const r = await api.post(`/documentos/subir-boleto/${edata.lead}/`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                  setEdata(prev => ({ ...prev, boleto_url: r.data.url }));
                  setBoletoFile(null);
                } catch(e) {
                  setBoletoError(e.response?.data?.error || 'Erro ao enviar boleto');
                } finally {
                  setUploadingBoleto(false);
                }
              }}
              style={{ ...S.btn('#f6c90e'), padding:'7px 14px', fontSize:12, opacity: uploadingBoleto ? 0.5 : 1 }}
            >
              {uploadingBoleto ? 'Enviando...' : boletoFile ? `Enviar: ${boletoFile.name}` : '📎 Anexar Boleto'}
            </button>
          </div>
        )}
        {boletoError && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{boletoError}</div>}
      </div>

      {/* CRT */}
      <div style={{ marginBottom:10 }}>
        <div style={{ fontSize:11, color:'#94a3b8', fontWeight:700, textTransform:'uppercase', letterSpacing:1, marginBottom:6 }}>CRT</div>
        {edata.crt_url ? (
          <a
            href={edata.crt_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, background:'rgba(74,222,128,0.1)', border:'1px solid rgba(74,222,128,0.3)', color:'#4ade80', fontSize:12, fontWeight:600, textDecoration:'none' }}
          >📄 Ver CRT</a>
        ) : (
          <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
            <input
              ref={crtInputRef}
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={e => { setCrtFile(e.target.files[0] || null); setCrtError(''); }}
              style={{ display:'none' }}
            />
            <button
              type="button"
              disabled={uploadingCrt}
              onClick={async () => {
                if (!crtFile) { crtInputRef.current?.click(); return; }
                setUploadingCrt(true); setCrtError('');
                try {
                  const fd = new FormData();
                  fd.append('arquivo', crtFile);
                  const r = await api.post(`/engenheiro/${edata.id}/subir-crt/`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                  setEdata(prev => ({ ...prev, crt_url: r.data.url }));
                  setCrtFile(null);
                } catch(e) {
                  setCrtError(e.response?.data?.error || 'Erro ao enviar CRT');
                } finally {
                  setUploadingCrt(false);
                }
              }}
              style={{ ...S.btn('#f6c90e'), padding:'7px 14px', fontSize:12, opacity: uploadingCrt ? 0.5 : 1 }}
            >
              {uploadingCrt ? 'Enviando...' : crtFile ? `Enviar: ${crtFile.name}` : '📎 Anexar CRT'}
            </button>
          </div>
        )}
        {crtError && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{crtError}</div>}
      </div>

      {/* Erro de ação */}
      {engStatusError && (
        <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'8px 12px', marginBottom:10, fontSize:12, color:'#f87171' }}>
          {engStatusError}
        </div>
      )}

      {/* CASE: aguardando_engenheiro → avançar para a_pagar_crt */}
      {st === 'aguardando_engenheiro' && (
        <PanelBox color="#fb923c">
          <div style={{ fontSize:12, color:'#fb923c', fontWeight:700, marginBottom:8 }}>🔶 Avançar para A Pagar CRT</div>
          <label style={S.label}>Data prevista pagamento CRT</label>
          <input style={S.input} type="date" key={engForm.data_crt_pagamento || 'k-crt'} defaultValue={engForm.data_crt_pagamento || ''} onBlur={ef('data_crt_pagamento')} />
          <button
            type="button"
            disabled={!engForm.data_crt_pagamento || savingEngStatus}
            onClick={() => avancarEng('a_pagar_crt', { data_crt_pagamento: engForm.data_crt_pagamento })}
            style={{ ...S.btn('#fb923c'), marginTop:10, padding:'8px 18px', opacity: (!engForm.data_crt_pagamento || savingEngStatus) ? 0.5 : 1 }}
          >{savingEngStatus ? 'Salvando...' : 'Avançar → A Pagar CRT'}</button>
        </PanelBox>
      )}

      {/* CASE: a_pagar_crt → avançar para analise_cemig */}
      {st === 'a_pagar_crt' && (
        <PanelBox color="#60a5fa">
          <div style={{ fontSize:12, color:'#60a5fa', fontWeight:700, marginBottom:8 }}>🔵 Análise CEMIG</div>
          <label style={S.label}>Data provável retorno CEMIG</label>
          <input style={S.input} type="date" key={engForm.data_analise_cemig_retorno || 'k-cemig'} defaultValue={engForm.data_analise_cemig_retorno || ''} onBlur={ef('data_analise_cemig_retorno')} />
          <button
            type="button"
            disabled={!engForm.data_analise_cemig_retorno || savingEngStatus}
            onClick={() => avancarEng('analise_cemig', { data_analise_cemig_retorno: engForm.data_analise_cemig_retorno })}
            style={{ ...S.btn('#60a5fa'), marginTop:10, padding:'8px 18px', opacity: (!engForm.data_analise_cemig_retorno || savingEngStatus) ? 0.5 : 1 }}
          >{savingEngStatus ? 'Salvando...' : 'Avançar → Análise CEMIG'}</button>
        </PanelBox>
      )}

      {/* CASE: analise_cemig — botões parecer */}
      {st === 'analise_cemig' && (
        <PanelBox color="#60a5fa">
          <div style={{ fontSize:12, color:'#60a5fa', fontWeight:700, marginBottom:8 }}>🔵 Em Análise CEMIG</div>
          {edata.data_analise_cemig_retorno && (
            <div style={{ fontSize:13, color:'#cbd5e1', marginBottom:8 }}>Retorno previsto CEMIG: <strong>{fmtDate(edata.data_analise_cemig_retorno)}</strong></div>
          )}
          {edata.parecer_acesso_status ? (
            <div style={{ marginTop:8, padding:'8px 12px', borderRadius:7, background: edata.parecer_acesso_status === 'aprovado' ? 'rgba(74,222,128,0.1)' : 'rgba(248,113,113,0.1)', border:`1px solid ${edata.parecer_acesso_status === 'aprovado' ? 'rgba(74,222,128,0.3)' : 'rgba(248,113,113,0.3)'}` }}>
              <span style={{ fontSize:13, fontWeight:700, color: edata.parecer_acesso_status === 'aprovado' ? '#4ade80' : '#f87171' }}>
                {edata.parecer_acesso_status === 'aprovado' ? '✅ Parecer Aprovado' : '❌ Parecer Reprovado'}
              </span>
              {edata.parecer_acesso_data && (
                <div style={{ fontSize:11, color:'#64748b', marginTop:2 }}>Data parecer: {fmtDT2(edata.parecer_acesso_data)}</div>
              )}
            </div>
          ) : (
            <>
              <div style={{ fontSize:12, color:'#94a3b8', marginBottom:8 }}>Definir parecer de acesso:</div>
              <div style={{ display:'flex', gap:8 }}>
                <button type="button" disabled={savingEngStatus}
                  onClick={async () => {
                    setSavingEngStatus(true); setEngStatusError('');
                    try {
                      await api.post(`/documentos/parecer-status/${edata.cliente}/`, { status: 'aprovado' });
                      const r = await api.get(`/engenheiro/${edata.id}/`);
                      setEdata(prev => ({ ...prev, ...r.data, parecer_acesso_status: 'aprovado', parecer_acesso_data: new Date().toISOString() }));
                    } catch(e) { setEngStatusError(e.response?.data?.error || 'Erro'); }
                    finally { setSavingEngStatus(false); }
                  }}
                  style={{ ...S.btn('#4ade80'), padding:'7px 14px', fontSize:12, opacity: savingEngStatus ? 0.5 : 1 }}>
                  ✅ Aprovado
                </button>
                <button type="button" disabled={savingEngStatus}
                  onClick={async () => {
                    setSavingEngStatus(true); setEngStatusError('');
                    try {
                      await api.post(`/documentos/parecer-status/${edata.cliente}/`, { status: 'reprovado' });
                      const r = await api.get(`/engenheiro/${edata.id}/`);
                      setEdata(prev => ({ ...prev, ...r.data, parecer_acesso_status: 'reprovado', parecer_acesso_data: new Date().toISOString() }));
                    } catch(e) { setEngStatusError(e.response?.data?.error || 'Erro'); }
                    finally { setSavingEngStatus(false); }
                  }}
                  style={{ ...S.btn('#f87171'), padding:'7px 14px', fontSize:12, opacity: savingEngStatus ? 0.5 : 1 }}>
                  ❌ Reprovado
                </button>
              </div>
            </>
          )}
        </PanelBox>
      )}

      {/* CASE: parecer_reprovado → voltar para analise_cemig */}
      {st === 'parecer_reprovado' && (
        <PanelBox color="#f87171">
          <div style={{ fontSize:12, color:'#f87171', fontWeight:700, marginBottom:8 }}>❌ Parecer Reprovado</div>
          {edata.parecer_acesso_data && (
            <div style={{ fontSize:12, color:'#64748b', marginBottom:10 }}>Data parecer: {fmtDT2(edata.parecer_acesso_data)}</div>
          )}
          <div style={{ fontSize:12, color:'#94a3b8', marginBottom:10 }}>Corrija as pendências e volte para análise CEMIG para novo parecer.</div>
          <button
            type="button"
            disabled={savingEngStatus}
            onClick={() => avancarEng('analise_cemig')}
            style={{ ...S.btn('#60a5fa'), padding:'8px 16px', fontSize:12, opacity: savingEngStatus ? 0.5 : 1 }}
          >{savingEngStatus ? 'Aguarde...' : '↩ Voltar para Análise CEMIG'}</button>
        </PanelBox>
      )}

      {/* CASE: aguardando_solicitar_vistoria / parecer_aprovado */}
      {(st === 'aguardando_solicitar_vistoria' || st === 'parecer_aprovado') && (() => {
        const instLabels = { aguardando_instalador:'Aguardando Instalador', instalacao_programada:'Instalação Programada', instalando:'Instalando', instalacao_concluida:'Instalação Concluída' };
        const instColors = { aguardando_instalador:'#64748b', instalacao_programada:'#60a5fa', instalando:'#f59e0b', instalacao_concluida:'#4ade80' };
        const instSt = edata.inst_status;
        const instCor = instColors[instSt] || '#94a3b8';
        const instLabel = instLabels[instSt] || instSt || '—';
        const concluido = instSt === 'instalacao_concluida';
        return (
          <PanelBox color="#a78bfa">
            <div style={{ fontSize:12, color:'#a78bfa', fontWeight:700, marginBottom:10 }}>✅ Parecer Aprovado — Aguardando Vistoria</div>
            <label style={S.label}>Status Instalador</label>
            <div style={{ display:'flex', alignItems:'center', gap:8, padding:'7px 11px', borderRadius:8, background:`${instCor}15`, border:`1px solid ${instCor}40`, marginBottom:12 }}>
              <span style={{ width:7, height:7, borderRadius:'50%', background:instCor, flexShrink:0 }} />
              <span style={{ fontSize:13, fontWeight:600, color:instCor }}>{instLabel}</span>
            </div>
            {concluido ? (
              <>
                {edata.inst_data_conclusao && (
                  <div style={{ fontSize:13, color:'#cbd5e1', marginBottom:12 }}>
                    Data Conclusão Instalação: <strong>{fmtDT2(edata.inst_data_conclusao)}</strong>
                  </div>
                )}
                <button
                  type="button"
                  disabled={savingEngStatus}
                  onClick={() => avancarEng('vistoria_solicitada')}
                  style={{ ...S.btn('#f6c90e'), padding:'8px 18px', fontSize:12, opacity: savingEngStatus ? 0.5 : 1 }}
                >{savingEngStatus ? 'Salvando...' : 'Avançar → Vistoria Solicitada'}</button>
              </>
            ) : (
              edata.inst_data_prevista && (
                <div style={{ fontSize:13, color:'#94a3b8' }}>
                  Data Prevista Conclusão: <strong style={{ color:'#cbd5e1' }}>{fmtDate(edata.inst_data_prevista)}</strong>
                </div>
              )
            )}
          </PanelBox>
        );
      })()}

      {/* CASE: vistoria_solicitada */}
      {st === 'vistoria_solicitada' && (
        <PanelBox color="#f6c90e">
          <div style={{ fontSize:12, color:'#f6c90e', fontWeight:700, marginBottom:8 }}>🔧 Vistoria Solicitada</div>
          {edata.vistoria_data_hora && (
            <div style={{ fontSize:13, color:'#cbd5e1', marginBottom:10 }}>
              📅 Prazo vistoria: <strong>{fmtDT2(edata.vistoria_data_hora)}</strong>
            </div>
          )}
          <label style={S.label}>Data e hora da conclusão da vistoria</label>
          <input style={S.input} type="datetime-local" key={engForm.data_vistoria_concluida || 'k-vist'} defaultValue={engForm.data_vistoria_concluida || ''} onBlur={ef('data_vistoria_concluida')} />
          <button
            type="button"
            disabled={!engForm.data_vistoria_concluida || savingEngStatus}
            onClick={() => avancarEng('vistoria_concluida', { data_vistoria_concluida: engForm.data_vistoria_concluida })}
            style={{ ...S.btn('#4ade80'), marginTop:10, padding:'8px 18px', opacity: (!engForm.data_vistoria_concluida || savingEngStatus) ? 0.5 : 1 }}
          >{savingEngStatus ? 'Salvando...' : '✅ Marcar Vistoria Concluída'}</button>
        </PanelBox>
      )}

      {/* CASE: vistoria_concluida */}
      {st === 'vistoria_concluida' && (
        <PanelBox color="#4ade80">
          <div style={{ fontSize:12, color:'#4ade80', fontWeight:700, marginBottom:6 }}>✅ Vistoria Concluída</div>
          {edata.data_vistoria_concluida && (
            <div style={{ fontSize:13, color:'#cbd5e1' }}>Concluída em: <strong>{fmtDT2(edata.data_vistoria_concluida)}</strong></div>
          )}
        </PanelBox>
      )}

      {/* Nota do chefe */}
      {edata.nota_chefe && (
        <div style={{ background:'rgba(246,201,14,0.06)', border:'1px solid rgba(246,201,14,0.25)', borderRadius:10, padding:14, marginTop:16 }}>
          <div style={{ fontSize:10, color:'#f6c90e', textTransform:'uppercase', letterSpacing:1, fontWeight:700, marginBottom:8 }}>📋 Nota do Chefe</div>
          <div style={{ fontSize:13, color:'#e2e8f0', lineHeight:1.6, marginBottom:10 }}>{edata.nota_chefe}</div>
          <div style={{ display:'flex', gap:12, fontSize:11, color:'#64748b' }}>
            <span>👤 {edata.nota_chefe_autor_nome || '—'}</span>
            <span>📅 {edata.nota_chefe_data
              ? new Date(edata.nota_chefe_data).toLocaleDateString('pt-BR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' })
              : '—'
            }</span>
          </div>
        </div>
      )}
    </div>
  );
}
